import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import logo from '../../assets/img/illustrations/falcon.png';
import { invitationService } from './service';
import './AcceptInvitation.css';

// Corporate group invites need a set-password step, so their tokens are handled by /group-invitation.
const isGroupInvitationToken = token => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.type === 'CORPORATE_GROUP_INVITATION';
  } catch (e) {
    return false;
  }
};

const AcceptInvitation = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Confirming your invitation…');

  const token = new URLSearchParams(window.location.search).get('token');
  const isGroupInvite = !!token && isGroupInvitationToken(token);

  const acceptInvitation = async () => {
    if (!token) {
      setStatus('error');
      setMessage('This invitation link is incomplete. Please request a new invitation.');
      return;
    }

    setStatus('loading');
    setMessage('Confirming your invitation…');
    const response = await invitationService.acceptInvitation(token);

    if (response.success) {
      setStatus('success');
      setMessage('Your invitation has been accepted. You can now sign in to your account.');
    } else {
      setStatus('error');
      setMessage(response.message);
    }
  };

  useEffect(() => {
    if (!isGroupInvite) {
      acceptInvitation();
    }
  }, []);

  if (isGroupInvite) {
    return <Redirect to={`/group-invitation?token=${encodeURIComponent(token)}`} />;
  }

  return (
    <div className="invitation-page">
      <div className="invitation-card" role="status" aria-live="polite">
        <img className="invitation-logo" src={logo} alt="Gizmeon" />
        {status === 'loading' && <span className="invitation-spinner" aria-label="Loading" />}
        {status === 'success' && <FaCheckCircle className="invitation-status-icon invitation-status-success" aria-hidden="true" />}
        {status === 'error' && <FaExclamationCircle className="invitation-status-icon invitation-status-error" aria-hidden="true" />}

        <h1>{status === 'success' ? 'Invitation accepted' : status === 'error' ? 'Unable to accept invitation' : 'Accepting invitation'}</h1>
        <p>{status === 'loading' ? 'Confirming your invitation...' : message}</p>

        {status === 'success' && (
          <Link className="invitation-primary-action" to="/login">
            Go to sign in
          </Link>
        )}
        {status === 'error' && (
          <button className="invitation-secondary-action" type="button" onClick={acceptInvitation}>
            Try again
          </button>
        )}
      </div>
    </div>
  );
};

export default AcceptInvitation;
